<template>
  <ul class="flex flex-wrap">
    <li v-for="link in links" :key="link.title" class="mr-4 md:mr-8">
      <router-link :to="{ name: link.routeName }" class="text--xs text-gray link">
        {{ $t(link.title) }}
      </router-link>
    </li>
  </ul>
</template>

<script setup>
import links from "../../static/footer-copyright-list"
</script>

<style lang="scss" scoped></style>
